function PageItems({ children }) {
  return <div className="flex flex-col gap-5 h-full">{children}</div>;
}
export default PageItems;
